import React, { useRef, useState } from 'react';
import axios from 'axios';
import { requireLogin } from '@/components/helpers/authHelpers';

interface BlockButtonProps {
  signedIn: boolean;
  blockableType: string;
  blockableId: number;
  blocked: boolean;
  noun?: string;
  blockCallback?: () => void;
  // For server-rendered cards (roommates/classifieds): remove the enclosing
  // .col from the DOM on toggle, mirroring ListingCards' removeCard behavior.
  removeCardOnToggle?: boolean;
}

export function BlockButton({
  signedIn,
  blockableType,
  blockableId,
  blocked,
  noun,
  blockCallback,
  removeCardOnToggle,
}: BlockButtonProps) {
  const [isBlocked, setIsBlocked] = useState(blocked);
  const iconRef = useRef<HTMLElement>(null);
  const displayNoun = noun || 'listing';

  const toggleBlockState = async () => {
    const msg = isBlocked
      ? `This ${displayNoun} will now be visible in search results.`
      : `Hide this ${displayNoun} from search results?`;

    if (window.confirm(msg)) {
      const params = { blockable_type: blockableType, blockable_id: blockableId };
      isBlocked ? await axios.delete('/api/blocks', { params }) : await axios.post('/api/blocks', params);

      setIsBlocked((oldState) => !oldState);
      if (blockCallback) blockCallback();
      if (removeCardOnToggle) iconRef.current?.closest('.col')?.remove();
    }
  };

  const click = () => {
    if (!signedIn) return requireLogin();
    toggleBlockState();
  };

  return (
    <i
      ref={iconRef}
      onClick={click}
      className={isBlocked ? 'listing-block fa fa-trash' : 'listing-block fa fa-trash inactive'}
    />
  );
}
